export const NotDisappointedIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_1_431)">
        <path
          d="M19.9999 39.1668C30.5854 39.1668 39.1666 30.5856 39.1666 20.0002C39.1666 9.41471 30.5854 0.833496 19.9999 0.833496C9.41446 0.833496 0.833252 9.41471 0.833252 20.0002C0.833252 30.5856 9.41446 39.1668 19.9999 39.1668Z"
          fill="#EF4444"
        />
        <path
          d="M19.9999 7.50016C24.1407 7.50047 28.1848 8.75106 31.6029 11.0882C35.021 13.4253 37.6538 16.7401 39.1566 20.5985C39.1566 20.3985 39.1666 20.2002 39.1666 20.0002C39.1666 14.9168 37.1472 10.0417 33.5528 6.44728C29.9583 2.85284 25.0832 0.833496 19.9999 0.833496C14.9166 0.833496 10.0415 2.85284 6.44704 6.44728C2.85259 10.0417 0.833252 14.9168 0.833252 20.0002C0.833252 20.2002 0.833252 20.3985 0.843252 20.5985C2.34601 16.7401 4.97879 13.4253 8.39691 11.0882C11.815 8.75106 15.8592 7.50047 19.9999 7.50016Z"
          fill="#FEE2E2"
        />
        <path
          d="M24.1667 15.6533C24.5202 16.2185 25.0116 16.6845 25.5947 17.0075C26.1778 17.3306 26.8335 17.5001 27.5001 17.5001C28.1667 17.5001 28.8223 17.3306 29.4054 17.0075C29.9885 16.6845 30.4799 16.2185 30.8334 15.6533"
          stroke="#00303E"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.8334 15.6533C15.4799 16.2185 14.9885 16.6845 14.4054 17.0075C13.8223 17.3306 13.1667 17.5001 12.5001 17.5001C11.8335 17.5001 11.1778 17.3306 10.5947 17.0075C10.0116 16.6845 9.52024 16.2185 9.16675 15.6533"
          stroke="#00303E"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.9999 39.1668C30.5854 39.1668 39.1666 30.5856 39.1666 20.0002C39.1666 9.41471 30.5854 0.833496 19.9999 0.833496C9.41446 0.833496 0.833252 9.41471 0.833252 20.0002C0.833252 30.5856 9.41446 39.1668 19.9999 39.1668Z"
          stroke="#00303E"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.5 30.8332H25.8333C25.8333 31.2752 26.0089 31.6991 26.3215 32.0117C26.634 32.3242 27.058 32.4998 27.5 32.4998C27.942 32.4998 28.366 32.3242 28.6785 32.0117C28.9911 31.6991 29.1667 31.2752 29.1667 30.8332V25.8332C29.1667 25.3911 28.9911 24.9672 28.6785 24.6547C28.366 24.3421 27.942 24.1665 27.5 24.1665C27.058 24.1665 26.634 24.3421 26.3215 24.6547C26.0089 24.9672 25.8333 25.3911 25.8333 25.8332H22.5"
          stroke="#00303E"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_431">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
